import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { BrowserRouter } from 'react-router-dom'
import { SWRConfig } from 'swr'
import { registerSW } from './utils/serviceWorkerRegistration'
import { initializePushNotifications } from './utils/pushNotifications'

// Set up beforeinstallprompt listener IMMEDIATELY (before React loads)
// This event can fire very early, even before page load completes
// Store the event in a global variable that components can access
if ('serviceWorker' in navigator) {
  window.__deferredPrompt = null;
  
  window.addEventListener('beforeinstallprompt', (e) => {
    console.log('✅ beforeinstallprompt event fired (captured in main.jsx)');
    e.preventDefault();
    window.__deferredPrompt = e;
    // Dispatch custom event so components can listen
    window.dispatchEvent(new CustomEvent('pwa-install-available', { detail: e }));
  });
  
  window.addEventListener('appinstalled', () => {
    console.log('✅ PWA installed (captured in main.jsx)');
    window.__deferredPrompt = null;
    window.dispatchEvent(new CustomEvent('pwa-installed'));
  });
}

// Register service worker
if ('serviceWorker' in navigator) {
  registerSW(
    () => {
      console.log('Service worker update available');
    },
    () => {
      console.log('Service worker activated');
    }
  ).then(async (registration) => {
    if (registration) {
      console.log('Service worker registered successfully');
      // Initialize push notifications (only checks for existing subscriptions,
      // does not request permission automatically)
      // Permission should be requested explicitly by user from settings
      initializePushNotifications(registration).catch(() => {
        // Silently handle - push notifications are optional
      });
    }
  }).catch(error => {
    console.error('Error registering service worker:', error);
  });
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <SWRConfig value={{
    provider: () => new Map(),
    isVisible: () => true, // forces SWR to behave like tab is always visible
  }}>
    <App />
  </SWRConfig>
  </StrictMode>,
)
